import {
  COLLECTION_SITES_URL,
  CUSTOMERS_URL,
  DELIVERY_SITES_URL,
  EMPLOYEES_URL,
  FARMS_URL,
  FIELDS_URL,
  HOME_URL,
  PRODUCTS_URL,
  SERVICES_URL,
  SILOS_URL,
  SPREADING_JOBS_URL,
  TIME_SHEETS_URL,
  TRAILERS_URL,
  VEHICLES_URL,
  TRANSPORT_JOBS_URL,
  WASTE_DELIVERY_SITES_URL
} from '@/utils/constants'

export const routeAssets: { [key: string]: string } = {
  [HOME_URL]: 'speedometer',
  [VEHICLES_URL]: 'tractor',
  [EMPLOYEES_URL]: 'account-multiple-outline',
  [CUSTOMERS_URL]: 'account-supervisor-circle-outline',
  [TRAILERS_URL]: 'truck-trailer',
  [FIELDS_URL]: 'land-fields',
  [FARMS_URL]: 'factory',
  [SERVICES_URL]: 'account-wrench',
  [WASTE_DELIVERY_SITES_URL]: 'storefront-outline',
  [DELIVERY_SITES_URL]: 'storefront-outline',
  [COLLECTION_SITES_URL]: 'warehouse',
  [PRODUCTS_URL]: 'gift',
  [SILOS_URL]: 'silo-outline',
  [TIME_SHEETS_URL]: 'calendar-month',
  [SPREADING_JOBS_URL]: 'image-area',
  [TRANSPORT_JOBS_URL]: 'image-area'
}
